var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 7.49935V5.83268C18.3337 5.39065 18.1581 4.96673 17.8455 4.65417C17.5329 4.34161 17.109 4.16602 16.667 4.16602H3.33366C2.89163 4.16602 2.46771 4.34161 2.15515 4.65417C1.84259 4.96673 1.66699 5.39065 1.66699 5.83268V14.166C1.66699 14.608 1.84259 15.032 2.15515 15.3445C2.46771 15.6571 2.89163 15.8327 3.33366 15.8327H16.667C16.667 15.8327 16.9506 15.7739 17.2828 15.6409C17.4689 15.5663 17.6702 15.4685 17.8455 15.3445C18.3337 14.9993 18.3337 14.166 18.3337 14.166V7.49935ZM18.3337 7.49935H5.00033",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.f6331100e9f14a574ec1eb2df00991d5.svg";
export { ForwardRef as ReactComponent };